import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LaunchCampaignsIcon(props: IconProps) {
  return (
    <Icon width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8071" r="36" fill="white" />
      <circle cx="36" cy="36.8071" r="21.4" stroke="#191A1C" strokeWidth="1.2" />
      <path
        d="M33.3875 36.3559C33.3875 37.0488 33.6628 37.7133 34.1527 38.2032C34.6426 38.6932 35.3071 38.9684 36 38.9684C36.6929 38.9684 37.3574 38.6932 37.8473 38.2032C38.3373 37.7133 38.6125 37.0488 38.6125 36.3559C38.6125 35.663 38.3373 34.9985 37.8473 34.5086C37.3574 34.0187 36.6929 33.7434 36 33.7434C35.3071 33.7434 34.6426 34.0187 34.1527 34.5086C33.6628 34.9985 33.3875 35.663 33.3875 36.3559Z"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0844 22.6511L31.9779 25.1051"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5562 28.9675L25.8187 30.2738"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8493 38.6474L24.4235 38.1929"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.9154 22.6511L40.0219 25.1051"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.4441 28.9675L38.2623 34.8457"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.151 38.6474L47.5768 38.1929"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="25.6"
        y="45.0492"
        width="20.8"
        height="5.51816"
        rx="2.75908"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
    </Icon>
  );
}
